import type React from "react";

interface SectionTitleProps {
  title: React.ReactNode;
  subtitle?: string;
  centered?: boolean;
  light?: boolean;
  label?: string;
}

export default function SectionTitle({ title, subtitle, centered = false, light = false, label }: SectionTitleProps) {
  return (
    <div className={`mb-10 md:mb-14 ${centered ? "text-center" : ""}`}>
      {label && (
        <p className={`text-xs md:text-sm font-medium tracking-[0.2em] uppercase mb-3 ${light ? "text-background-300" : "text-foreground-500"}`}>
          {label}
        </p>
      )}
      <h2 className={`text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight font-heading ${light ? "text-background-50" : "text-foreground-950"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`text-sm md:text-base mt-3 md:mt-4 max-w-2xl leading-relaxed ${centered ? "mx-auto" : ""} ${light ? "text-background-200" : "text-foreground-600"}`}>
          {subtitle}
        </p>
      )}
      <div className={`mt-4 md:mt-5 w-12 h-[2px] rounded-full bg-primary-500 ${centered ? "mx-auto" : ""}`} />
    </div>
  );
}